<template>
    <section class="container-fluid header-pc d-none d-md-block" :class="isFixed?'fixed':''">
        <div class="container">
            <router-link class="logo" to="/">
                <img src="@/assets/images/cstlogo.png" alt="">
            </router-link>
            <div class="center">
                <router-link class="item" to="/square">模型广场</router-link>
                <i class="line"></i>
                <router-link class="item" to="/dataSet">数据集</router-link>
                <i class="line"></i>
                <router-link class="item" to="/service">软件与服务</router-link>
                <i class="line"></i>
                <a class="item" href="https://scihorizon.cn/" target="_blank">科学地平线</a>
            </div>
            <div class="right">
                <div class="search-box">
                  <span style="width: 1rem;display: inline-block;"></span>
<!--                    <input type="text" class="uc-input" placeholder="模型、数据集、应用软件" value="" placeholder-class="uc-phColor" />-->
<!--                    <div class="btn"><img src="@/assets/images/icon-search.png" alt=""></div>-->
                </div>
                <div class="link-box">
                    <a class="link" href="https://www.cstnet.cn/" target="_blank" rel="noopener" > <img src="@/assets/images/kxylogo.png" alt=""> </a>
                    <a class="link" href="https://cnic.cas.cn/" target="_blank" rel="noopener" > <img src="@/assets/images/cniclogo.png" alt=""> </a>
                
                </div>
                
                <a class="uc-btn blue px-2" href="https://aiworkbench.cstcloud.cn/" target="_blank" rel="noopener" > 登录</a>
            </div>
        </div>
    </section>
    <!-- 手机版 -->
    <section class="header-phone d-md-none">
        <router-link class="logo" to="/">
            <img src="@/assets/images/logo.png" alt="">
        </router-link>
        <div class="btn-menu" :class="showMenu?'on':''" @click="showMenu = !showMenu"></div>
    </section>
    <div class="alert-menu" v-if="showMenu">
        <div class="over-close" @click="showMenu = false"></div>
        <div class="box">
            <ul class="list">
                <li>
                    <router-link class="" to="/square">模型广场</router-link>
                </li>
                <li>
                    <router-link class="" to="/dataSet">数据集</router-link>
                </li>
                <li>
                    <router-link class="" to="/service">软件与服务</router-link>
                </li>
                <li>
                  <a href="https://scihorizon.cn/" target="_blank">科学地平线2</a>
                </li>
            </ul>
            <ul class="list list-secondary">
                <li>
                    <a href="https://mail.cstnet.cn/" target="_blank" rel="noopener">邮箱</a>
                </li>
                <li>
                    <a href="https://pan.cstcloud.cn/" target="_blank" rel="noopener">科技云盘</a>
                </li>
                <li>
                    <a href="/#/serviceDetail?id=573" target="_blank" rel="noopener">科技云会（腾讯版）</a>
                </li>
                <li>
                    <a href="https://www1.cstcloud.cn/#servicelist_section" target="_blank" rel="noopener">认证服务列表</a>
                </li>
                <li>
                    <a href="https://www1.cstcloud.cn/#resrecom_section" target="_blank" rel="noopener">学科资源</a>
                </li>
            </ul>
            <ul class="list list-secondary">
                <li>
                    <a href="https://www1.cstcloud.cn/" target="_blank" rel="noopener">回到旧版</a>
                </li>
                <li>
                    <a href="https://www.cstcloud.net/" target="_blank" rel="noopener">English</a>
                </li>
            </ul>
            <div class="search-box">
<!--                <input type="text" class="uc-input" placeholder="模型、数据集、应用软件" value="" placeholder-class="uc-phColor" />-->
<!--                <div class="btn"><img src="@/assets/images/icon-search.png" alt=""></div>-->
            </div>
        </div>
    </div>
</template>
<script setup>
    import { ref, onMounted, onUnmounted } from 'vue'
    const showMenu = ref(false)
    const name = ref('小')
    const isFixed = ref(false)
    const handleScroll = () => {
        isFixed.value = window.pageYOffset > 300
    }
    let timer = null
    const throttledScroll = () => {
        if (!timer) {
            timer = setTimeout(() => {
                handleScroll()
                timer = null
            }, 50)
        }
    }
    onMounted(() => {
        window.addEventListener('scroll', throttledScroll)
    })
    onUnmounted(() => {
        window.removeEventListener('scroll', throttledScroll)
        clearTimeout(timer)
    })
</script>
